import { createFileRoute } from '@tanstack/react-router';

import { Integrations, Settings } from '@mint-sdk/api-omni-trafficking';

export const Route = createFileRoute(
  '/_secured/campaign/$campaignId/trafficking/',
)({
  loaderDeps: ({ search: { activityId } }) => ({ activityId }),
  async loader({ context, deps: { activityId } }) {
    const isOmniTrafficking = await context.isFlagEnabled(
      '@mint/arm',
      'omniTrafficking',
    );

    if (isOmniTrafficking) {
      await context.getInstance('i18n', '@myn/omni-trafficking');
      await context.getInstance('i18n', '@mint-lib/ag-grid');

      await context.prefetchQuery(
        Integrations.getIntegrationList({ params: {} }),
      );
    } else {
      await context.getInstance('i18n', '@myn/trafficking');
    }

    if (isOmniTrafficking && activityId) {
      await context.prefetchQuery(
        Settings.getSettings({
          params: {
            activityId: activityId,
          },
        }),
      );
    }
  },
});
